import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

/*Laravel*/
import { environment } from '@env/environment';
import { HttpServiceUtil } from './http-service-util';
import { ToastrService } from 'ngx-toastr';
import { AuthSessionService } from '@services/auth-session.service';

@Injectable()
export class ImportService {
  url = environment.urlToApi;
  headersToAuth: HttpHeaders;

  constructor(private _http: HttpClient, private toastr: ToastrService, private authSession: AuthSessionService) {
    this.setHeaders();
  }

  setHeaders() {
    this.headersToAuth = this.authSession.buildHeaders({ Accept: 'application/json' });
  }

  post = (route, data) =>
    new Promise((resolve, reject) => {
      this.setHeaders();

      this._http
        .post(this.url + route, data, { headers: this.headersToAuth })
        .subscribe(
          (res) => resolve(res),
          (rej: any) => {
            if (rej.status == 403)
              reject({ status: 'ERRO', message: 'Não autorizado.' });
            HttpServiceUtil.errorHandling(rej, this.toastr);
            reject(rej);
          }
        );
      // return this.http.put(contentItem._links.template.href, template._links.self.href, {headers: headers});
    });
}
